import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OrderErrorGuard implements CanActivate {
  private hasValidAccess = false;
  private router = inject(Router);


  canActivate(): boolean {
    if (this.hasValidAccess) {
      this.hasValidAccess = false;
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }

  grantAccess(): void {
    this.hasValidAccess = true;
  }
}

